/* Fun Cases PDP:
   · Colour-sides image swap via the per-variant Cloudinary map.
   · Variant option selection (Case Type / Size / Colour) → resolves the variant,
     updates price / availability / image. Phone Model is handled by the picker.
   · Thumbnail gallery. Product recommendations hydration. */
(function () {
  'use strict';

  function initPDP() {
    var pdp = document.querySelector('[data-pdp]');
    if (!pdp) return;
    var img = pdp.querySelector('[data-pdp-image]');
    var idEl = pdp.querySelector('[data-pdp-variant-id]');

    var cloud = {};
    var cloudEl = pdp.querySelector('[data-pdp-cloud]');
    if (cloudEl) { try { cloud = JSON.parse(cloudEl.textContent); } catch (e) { cloud = {}; } }

    var variants = [];
    var varEl = pdp.querySelector('[data-pdp-variants]');
    if (varEl) { try { variants = JSON.parse(varEl.textContent); } catch (e) { variants = {}; } }

    var priceEl = pdp.querySelector('[data-pdp-price]');
    var coinsEl = pdp.querySelector('[data-usp-coins]');
    var addBtn = pdp.querySelector('[data-pdp-submit]');
    var addLabel = pdp.querySelector('[data-pdp-add-label]');
    var loader = pdp.querySelector('[data-pdp-loader]');
    var optionsWrap = pdp.querySelector('[data-pdp-options]');

    /* current colour side (from checked radio, else the label, else black) */
    var currentColour = 'black';
    var checkedSide = pdp.querySelector('input[name="properties[Colour Sides]"]:checked');
    if (checkedSide) currentColour = (checkedSide.getAttribute('data-side') || 'black');

    function preload(url, cb) {
      var pre = new Image();
      pre.onload = function () { cb(true); };
      pre.onerror = function () { cb(false); };
      pre.src = url;
    }
    var imageSwapPending = false;   // set when setImage accepts a NEW url (swap lands after preload)
    /* Shopify image_url emits PROTOCOL-RELATIVE urls ("//cdn...") while img.src resolves to
       absolute ("https://cdn..."), so a raw === never matched and every option change looked
       like an image swap — which is why picking a size scrolled the page on mobile. Resolve
       both against the document before comparing. */
    function sameImage(a, b) {
      if (!a || !b) return false;
      try { return new URL(a, location.href).href === new URL(b, location.href).href; }
      catch (e) { return a === b; }
    }
    function setImage(url) {
      if (!img || !url || sameImage(img.src, url)) return;
      imageSwapPending = true;
      if (loader) loader.hidden = false;
      preload(url, function (ok) {
        if (ok) img.src = url;
        if (loader) loader.hidden = true;
        syncThumbActive(url);
      });
    }
    /* Cloudinary colour image first (for the current variant + colour), else the
       variant's own image. */
    function updateImage() {
      var vid = idEl ? idEl.value : null;
      var url = null;
      var entry = vid && cloud[vid];
      if (entry) url = entry[currentColour] || entry.black || entry.clear || entry.white || null;
      if (!url) {
        var v = currentVariant();
        if (v && v.image) url = v.image;
      }
      if (url) setImage(url);
    }
    function currentVariant() {
      if (!idEl) return null;
      for (var i = 0; i < variants.length; i++) { if (String(variants[i].id) === String(idEl.value)) return variants[i]; }
      return null;
    }

    /* ---- Colour sides ---- */
    pdp.addEventListener('change', function (e) {
      var r = e.target.closest('input[name="properties[Colour Sides]"]');
      if (!r) return;
      currentColour = r.getAttribute('data-side') || 'black';
      pdp.querySelectorAll('.pdp-side').forEach(function (l) { l.classList.remove('is-active'); });
      if (r.closest('.pdp-side')) r.closest('.pdp-side').classList.add('is-active');
      var cur = pdp.querySelector('[data-sides-current]');
      if (cur) cur.textContent = currentColour.charAt(0).toUpperCase() + currentColour.slice(1);
      updateImage();
    });

    /* ---- Variant options (Case Type / Size / Colour) ---- */
    if (optionsWrap) {
      var modelPos = parseInt(optionsWrap.getAttribute('data-model-pos') || '0', 10);
      var modelVal = optionsWrap.getAttribute('data-model-value') || '';
      function resolve() {
        var pills = {};
        optionsWrap.querySelectorAll('.pdp-option').forEach(function (g) {
          var c = g.querySelector('input:checked');
          if (c) pills[c.getAttribute('data-opt-pos')] = c.value;
        });
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i], ok = true;
          if (modelPos && modelVal && v.options[modelPos - 1] !== modelVal) ok = false;
          if (ok) { for (var pos in pills) { if (v.options[parseInt(pos, 10) - 1] !== pills[pos]) { ok = false; break; } } }
          if (ok) return v;
        }
        return null;
      }
      // Is there a SELLABLE variant for the current model with option[pos] overridden
      // to val, holding the OTHER selected options? Requires the variant to be
      // available (in stock / for sale) — so an option value that exists only as an
      // unavailable variant (e.g. Tough on Design-Your-Own before we switch it on)
      // greys out rather than reading as a real choice.
      function variantExistsFor(pos, val) {
        var pills = {};
        optionsWrap.querySelectorAll('.pdp-option').forEach(function (g) {
          var c = g.querySelector('input:checked');
          if (c) pills[c.getAttribute('data-opt-pos')] = c.value;
        });
        pills[String(pos)] = val;
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i], ok = true;
          if (modelPos && modelVal && v.options[modelPos - 1] !== modelVal) ok = false;
          if (ok) { for (var p in pills) { if (v.options[parseInt(p, 10) - 1] !== pills[p]) { ok = false; break; } } }
          if (ok && v.available) return true;
        }
        return false;
      }
      // Grey out option values that have NO variant for the selected model (e.g. a phone
      // that isn't sold in "Standard"), so every offered choice actually swaps the image.
      function refreshOptionAvailability() {
        optionsWrap.querySelectorAll('.pdp-opt-pill').forEach(function (l) {
          var inp = l.querySelector('input[data-opt-pos]'); if (!inp) return;
          if (inp.checked) { l.classList.remove('is-unavailable'); inp.disabled = false; return; }
          if (variantExistsFor(inp.getAttribute('data-opt-pos'), inp.value)) {
            l.classList.remove('is-unavailable'); inp.disabled = false;
          } else {
            l.classList.add('is-unavailable'); inp.disabled = true;
          }
        });
      }
      function markActive(r, group) {
        group.querySelectorAll('.pdp-opt-pill').forEach(function (l) { l.classList.remove('is-active'); });
        var pill = r.closest('.pdp-opt-pill'); if (pill) pill.classList.add('is-active');
        var cur = group.querySelector('[data-opt-current]'); if (cur) cur.textContent = r.value;
      }
      function syncSelection() {
        // Toggle the Black-only restriction FIRST, so it always runs even if
        // resolve() finds no variant (e.g. an unavailable combination).
        applyCaseTypeRestriction();
        refreshOptionAvailability();
        var v = resolve();
        if (v) {
          if (idEl) idEl.value = v.id;
          if (priceEl) { priceEl.innerHTML = v.on_sale ? ('<span class="pdp-price__now">' + v.price + '</span> <s class="pdp-price__was">' + v.compare_at + '</s> <span class="pdp-price__save">Save ' + v.save + '</span>') : v.price; }
          if (coinsEl && v.coins != null) coinsEl.textContent = v.coins;   // keep Case Coins in sync with the variant price
          if (addBtn) {
            addBtn.disabled = !v.available;
            // Update ONLY the label span so the bag icon (a sibling span) survives.
            if (addLabel) addLabel.innerHTML = v.available ? 'Add to bag &rarr;' : 'Sold out';
            else addBtn.textContent = v.available ? 'Add to bag →' : 'Sold out';
          }
        }
        updateImage();   // always refresh the image on any option change (fixes Bumper→Standard)
        if (window.__fcToughGallery) window.__fcToughGallery();   // swap gallery to Tough/MagSafe mockups
      }
      function applyChosen(r, group) {
        imageSwapPending = false;
        markActive(r, group);
        group.setAttribute('data-committed', r.value);
        syncSelection();
        // Mobile: if this option change is swapping the featured image (setImage accepted
        // a new url — the swap itself lands after preload), scroll the gallery back into
        // view so the shopper actually sees it. readyState guard skips page-load auto-selects.
        if (window.innerWidth < 900 && document.readyState === 'complete' && imageSwapPending) {
          var frame = pdp.querySelector('.pdp-gallery__frame');
          if (frame) frame.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
      // Re-select the last committed value in a group (used to undo a change the shopper cancels).
      function revertGroup(group) {
        var val = group.getAttribute('data-committed'); if (val == null) return;
        var ci = null;
        group.querySelectorAll('.pdp-opt-pill input').forEach(function (inp) { if (inp.value === val) ci = inp; });
        if (ci) { ci.checked = true; markActive(ci, group); }
        syncSelection();
      }
      optionsWrap.addEventListener('change', function (e) {
        var r = e.target.closest('input[data-opt-pos]');
        if (!r) return;
        var group = r.closest('.pdp-option');
        // If there's an unsaved personalised design, warn before switching variant.
        if (window.FCPz && FCPz.hasDesign()) {
          revertGroup(group);   // undo the browser's selection while we ask
          FCPz.confirmReset(function () { applyChosen(r, group); });   // only proceeds if they discard
          return;
        }
        applyChosen(r, group);
      });
      // Remember each group's starting value so we can revert a cancelled change.
      optionsWrap.querySelectorAll('.pdp-option').forEach(function (g) {
        var c = g.querySelector('input:checked'); if (c) g.setAttribute('data-committed', c.value);
      });
      refreshOptionAvailability();   // initial pass for the loaded model
      // Deep-link: ?ct=<Case Type> (e.g. from a Flip PDP's "Tough" tile) pre-selects that case type,
      // if it's available for the current model.
      (function () {
        var raw = (location.search.match(/[?&]ct=([^&]+)/) || [])[1];
        if (!raw) return;
        var want = decodeURIComponent(raw.replace(/\+/g, ' ')).toLowerCase().trim();
        var groups = optionsWrap.querySelectorAll('.pdp-option');
        for (var i = 0; i < groups.length; i++) {
          var lbl = groups[i].querySelector('.pdp-option__label');
          if (!lbl || !/case type/i.test(lbl.textContent)) continue;
          var inp = null;
          groups[i].querySelectorAll('.pdp-opt-pill input').forEach(function (c) {
            if ((c.value || '').toLowerCase().trim() === want && !c.disabled) inp = c;
          });
          if (inp && !inp.checked) { inp.checked = true; applyChosen(inp, groups[i]); }
          break;
        }
      })();
    }

    /* ---- Bumper / MagSafe case types are only sold with Black sides ---- */
    function applyCaseTypeRestriction() {
      var restrict = false;
      if (optionsWrap) {
        optionsWrap.querySelectorAll('input:checked').forEach(function (c) {
          var v = (c.value || '').toLowerCase();
          // Bumper + Standard MagSafe are black-only. (MagSafe was renamed to "Standard MagSafe";
          // exclude "MagSafe Tough" which is full-wrap.) Match any magsafe that isn't tough.
          if (v === 'bumper' || (v.indexOf('magsafe') !== -1 && v.indexOf('tough') === -1)) restrict = true;
        });
      }
      pdp.querySelectorAll('.pdp-side').forEach(function (l) {
        var inp = l.querySelector('input'); if (!inp) return;
        if (inp.getAttribute('data-side') === 'black') return;
        if (restrict) {
          if (!inp.disabled) { inp.disabled = true; l.classList.add('is-oos'); l.setAttribute('data-bumper-off', ''); }
          if (inp.checked) {
            var b = pdp.querySelector('.pdp-side input[data-side="black"]');
            if (b && !b.disabled) { b.checked = true; b.dispatchEvent(new Event('change', { bubbles: true })); }
          }
        } else if (l.hasAttribute('data-bumper-off')) {
          // Restore to the STOCK state, not to enabled: a side can be both bumper-restricted and
          // genuinely out of stock, and unconditionally re-enabling it resurrected the bug above.
          inp.disabled = inp.hasAttribute('data-stock-oos');
          if (!inp.disabled) l.classList.remove('is-oos');
          l.removeAttribute('data-bumper-off');
        }
      });
    }
    applyCaseTypeRestriction();

    /* ---- Thumbnails ---- */
    var thumbs = pdp.querySelector('[data-pdp-thumbs]');
    function syncThumbActive(url) {
      if (!thumbs) return;
      thumbs.querySelectorAll('.pdp-thumb').forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-pdp-thumb') === url);
      });
    }
    if (thumbs) {
      thumbs.addEventListener('click', function (e) {
        var t = e.target.closest('[data-pdp-thumb]');
        if (!t) return;
        var src = t.getAttribute('data-pdp-thumb');
        if (src && img) img.src = src;
        thumbs.querySelectorAll('.pdp-thumb').forEach(function (b) { b.classList.remove('is-active'); });
        t.classList.add('is-active');
      });

      /* ---- Prev/next arrows: cycle through the gallery images ---- */
      var prevBtn = pdp.querySelector('[data-pdp-prev]');
      var nextBtn = pdp.querySelector('[data-pdp-next]');
      function thumbList() { return Array.prototype.slice.call(thumbs.querySelectorAll('.pdp-thumb')); }
      function activeIndex(list) { for (var i = 0; i < list.length; i++) { if (list[i].classList.contains('is-active')) return i; } return -1; }
      function srcIndex(list) { var s = img ? img.src : ''; for (var i = 0; i < list.length; i++) { if (list[i].getAttribute('data-pdp-thumb') === s) return i; } return 0; }
      function goBy(delta) {
        var list = thumbList(); if (!list.length) return;
        var i = activeIndex(list); if (i < 0) i = srcIndex(list);
        i = (i + delta + list.length) % list.length;
        var t = list[i], src = t.getAttribute('data-pdp-thumb');
        if (src && img) img.src = src;
        list.forEach(function (b) { b.classList.remove('is-active'); });
        t.classList.add('is-active');
      }
      if (prevBtn) prevBtn.addEventListener('click', function () { goBy(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goBy(1); });
    }

    /* ---- Tough / MagSafe Tough dynamic gallery: pull the extra mockup angles for the selected
       model + case type from the custom.tough_mockups metafield (no extra Shopify images). ---- */
    (function () {
      var toughMockups = null;
      var tmEl = pdp.querySelector('[data-pdp-tough-mockups]');
      if (tmEl) { try { toughMockups = JSON.parse(tmEl.textContent); } catch (e) {} }
      if (!toughMockups) return;
      var thumbsEl = pdp.querySelector('[data-pdp-thumbs]');
      if (!thumbsEl) return;
      var prevBtn = pdp.querySelector('[data-pdp-prev]'), nextBtn = pdp.querySelector('[data-pdp-next]');
      function curModel() { var w = pdp.querySelector('[data-pdp-options]'); return (w && w.getAttribute('data-model-value')) || ''; }
      function curCaseType() { var el = pdp.querySelector('[data-pdp-ct] input:checked'); return el ? (el.value || '').trim() : ''; }
      function rebuild(urls) {
        thumbsEl.innerHTML = urls.map(function (u, i) {
          return '<button type="button" class="pdp-thumb' + (i === 0 ? ' is-active' : '') + '" data-pdp-thumb="' + u +
            '" aria-label="View image ' + (i + 1) + '"><img src="' + u + '" alt="" loading="lazy" width="90" height="90"></button>';
        }).join('');
      }
      function toggleNav(show) {
        thumbsEl.style.display = show ? '' : 'none';
        if (prevBtn) prevBtn.style.display = show ? '' : 'none';
        if (nextBtn) nextBtn.style.display = show ? '' : 'none';
      }
      window.__fcToughGallery = function () {
        var urls = (toughMockups[curModel()] || {})[curCaseType()];
        if (urls && urls.length) { rebuild(urls); setImage(urls[0]); toggleNav(true); }
        else { thumbsEl.innerHTML = ''; toggleNav(false); }   // Standard: just the design image
      };
      window.__fcToughGallery();   // initial state (handles ?ct=Tough deep-links)
    })();

    /* ---- Engraving field (necklaces / keyrings): show when the "Engraving" option = Yes ---- */
    var engField = pdp.querySelector('[data-engraving-field]');
    var engInput = pdp.querySelector('[data-engraving]');
    if (engField && engInput) {
      var engCount = pdp.querySelector('[data-engraving-count]');
      function engravingIsYes() {
        var groups = pdp.querySelectorAll('.pdp-option');
        for (var i = 0; i < groups.length; i++) {
          var lbl = groups[i].querySelector('.pdp-option__label');
          if (lbl && /engraving/i.test(lbl.textContent)) {
            var c = groups[i].querySelector('input:checked');
            return !!(c && /yes/i.test(c.value));
          }
        }
        return false;
      }
      function syncEngraving() {
        var yes = engravingIsYes();
        engField.hidden = !yes;
        engInput.disabled = !yes;                       // disabled inputs aren't submitted → no empty prop
        if (!yes) { engInput.value = ''; if (engCount) engCount.textContent = '0'; }
      }
      // Allow letters, numbers, spaces and a few name-friendly marks; strip emojis / special chars.
      engInput.addEventListener('input', function () {
        var clean = engInput.value.replace(/[^A-Za-z0-9 &'.\-]/g, '');
        if (clean !== engInput.value) engInput.value = clean;
        if (engCount) engCount.textContent = String(engInput.value.length);
      });
      pdp.addEventListener('change', function (e) { if (e.target.closest('.pdp-option')) syncEngraving(); });
      syncEngraving();
    }

    /* ---- Collapsible tabs: animate open/close (native <details> snaps shut, so we drive the height) ---- */
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    pdp.querySelectorAll('.pdp-tab').forEach(function (tab) {
      var sum = tab.querySelector('summary');
      var body = tab.querySelector('.pdp-tab__body');
      if (!sum || !body) return;
      sum.addEventListener('click', function (e) {
        if (reduceMotion) return;                 // honour reduced motion → native instant toggle
        e.preventDefault();
        if (tab._animating) return;
        tab._animating = true;
        var onEnd = function (te) {
          if (te.propertyName && te.propertyName !== 'height') return;
          body.removeEventListener('transitionend', onEnd);
          if (tab._closing) { tab.open = false; tab._closing = false; }
          body.style.height = ''; tab._animating = false;
        };
        if (tab.open) {
          tab._closing = true;
          body.style.height = body.scrollHeight + 'px';
          requestAnimationFrame(function () { body.style.height = '0px'; });
          body.addEventListener('transitionend', onEnd);
        } else {
          tab.open = true;
          var h = body.scrollHeight;
          body.style.height = '0px';
          requestAnimationFrame(function () { body.style.height = h + 'px'; });
          body.addEventListener('transitionend', onEnd);
        }
      });
    });

    initUpsells(pdp);
  }

  /* ---- Upsell add: auto-resolve the variant to the shopper's phone model; only pop a picker
     when a genuine choice (colour/size, or unknown model) remains. Single-variant items just
     submit (cart.js AJAX-adds + opens the drawer). ---- */
  function initUpsells(scope) {
    var popup = null;
    function esc(s) { return (s == null ? '' : String(s)).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function modelIndex(options) { for (var i = 0; i < options.length; i++) { var n = (options[i] || '').toLowerCase(); if (n.indexOf('phone') > -1 || n.indexOf('model') > -1) return i; } return -1; }
    function distinctVals(data, idx) { var out = []; data.variants.forEach(function (v) { if (out.indexOf(v.options[idx]) < 0) out.push(v.options[idx]); }); return out; }
    function resolveVariant(data, sel) {
      var fallback = null;
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i], ok = true;
        for (var j = 0; j < sel.length; j++) { if (sel[j] != null && v.options[j] !== sel[j]) { ok = false; break; } }
        if (ok) { if (v.available) return v; if (!fallback) fallback = v; }
      }
      return fallback;
    }
    function commit(form, v) {
      var idEl = form.querySelector('[data-upsell-id]'); if (idEl) idEl.value = v.id;
      var mEl = form.querySelector('[data-upsell-msku]');
      if (mEl) { if (v.msku) { mEl.value = v.msku; mEl.disabled = false; } else { mEl.disabled = true; } }
    }
    function submitForm(form) { if (form.requestSubmit) form.requestSubmit(); else form.submit(); }
    function close() { if (popup) { popup.remove(); popup = null; document.body.style.overflow = ''; } }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    scope.addEventListener('click', function (e) {
      var addBtn = e.target.closest('[data-upsell-add]');
      if (!addBtn) return;
      var form = addBtn.closest('[data-upsell-form]');
      if (!form) return;
      var dataEl = form.querySelector('[data-upsell-data]');
      if (!dataEl) return;   // single variant → let it submit natively
      var data; try { data = JSON.parse(dataEl.textContent); } catch (_) { return; }
      e.preventDefault();
      var mi = modelIndex(data.options);
      var sel = data.options.map(function () { return null; });
      var modelResolved = false;
      if (mi > -1 && data.model && distinctVals(data, mi).indexOf(data.model) > -1) { sel[mi] = data.model; modelResolved = true; }
      var need = [];
      for (var i = 0; i < data.options.length; i++) {
        if (i === mi && modelResolved) continue;
        var vals = distinctVals(data, i);
        if (vals.length > 1) need.push(i); else sel[i] = vals[0];
      }
      if (!need.length) { var v = resolveVariant(data, sel); if (v) { commit(form, v); submitForm(form); } return; }
      openPicker(form, data, sel, need, modelResolved);
    });

    function openPicker(form, data, sel, need, modelResolved) {
      need.forEach(function (idx) {
        var vals = distinctVals(data, idx); sel[idx] = vals[0];
        for (var k = 0; k < vals.length; k++) { var t = sel.slice(); t[idx] = vals[k]; if (resolveVariant(data, t)) { sel[idx] = vals[k]; break; } }
      });
      close();
      popup = document.createElement('div');
      popup.className = 'upv';
      popup.innerHTML = '<div class="upv__box" role="dialog" aria-modal="true">' +
        '<button class="upv__x" data-upv-close aria-label="Close">&times;</button>' +
        (data.img ? '<div class="upv__img"><img src="' + data.img + '" alt=""></div>' : '') +
        '<h3 class="upv__title">' + esc(data.title) + '</h3>' +
        (modelResolved ? '<p class="upv__fits">Fits your ' + esc(data.model) + '</p>' : '') +
        '<div class="upv__opts"></div>' +
        '<button class="upv__add" data-upv-add></button></div>';
      var opts = popup.querySelector('.upv__opts');
      need.forEach(function (idx) {
        var grp = document.createElement('div'); grp.className = 'upv__grp';
        grp.innerHTML = '<label class="upv__lbl">' + esc(data.options[idx]) + '</label>';
        var wrap = document.createElement('div'); wrap.className = 'upv__selwrap';
        var selEl = document.createElement('select'); selEl.className = 'upv__select'; selEl.setAttribute('data-idx', idx);
        distinctVals(data, idx).forEach(function (val) {
          var o = document.createElement('option'); o.value = val; o.textContent = val;
          if (sel[idx] === val) o.selected = true;
          selEl.appendChild(o);
        });
        wrap.appendChild(selEl); grp.appendChild(wrap); opts.appendChild(grp);
      });
      document.body.appendChild(popup); document.body.style.overflow = 'hidden';
      refresh(data, sel);
      requestAnimationFrame(function () { popup.classList.add('is-open'); });
      popup.addEventListener('change', function (e) {
        var s = e.target.closest('.upv__select'); if (!s) return;
        sel[+s.getAttribute('data-idx')] = s.value;
        refresh(data, sel);
      });
      popup.addEventListener('click', function (e) {
        if (e.target === popup || e.target.closest('[data-upv-close]')) { close(); return; }
        if (e.target.closest('[data-upv-add]')) {
          var v = resolveVariant(data, sel);
          if (v && v.available) { commit(form, v); close(); submitForm(form); }
        }
      });
    }
    function refresh(data, sel) {
      if (!popup) return;
      var v = resolveVariant(data, sel), addb = popup.querySelector('[data-upv-add]');
      if (v && v.available) { addb.disabled = false; addb.textContent = 'Add · ' + v.price; }
      else { addb.disabled = true; addb.textContent = v ? 'Sold out' : 'Unavailable'; }
    }
  }

  /* ---- Product recommendations ---- */
  function initRecs() {
    var el = document.querySelector('[data-recs]');
    if (!el) return;
    if (el.getAttribute('data-recs-count') && parseInt(el.getAttribute('data-recs-count'), 10) > 0) return;
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recs]');
        if (fresh && fresh.innerHTML.trim()) {
          el.innerHTML = fresh.innerHTML;
          if (window.__fcInitScrollers) window.__fcInitScrollers(el);
        }
      })
      .catch(function () {});
  }

  function boot() { initPDP(); initRecs(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();

